import BuilderModel from "./builderModel";

export default class LicenseBuilderModel extends BuilderModel {
  license: any;
  except = ['license'];
}